import Axios from 'axios';
import * as config from '../config/config';

let simplyBookServer = 'https://user-api.simplybook.me';
let backendServer = Axios.create({
    baseURL: 'https://api.backand.com/1/',
    timeout: 10000,
    headers: {
        'AnonymousToken': '57827708-cfca-4aa6-ab79-2e520aa6c75d',
        'Content-Type': 'application/json'
    }
});
let firebaseServer = Axios.create({
    baseURL: 'https://us-central1-gifturephotoboothapp.cloudfunctions.net/',
    timeout: 10000
});

let accessToken = null;
let axiosInstance = null;

export const requestToken = () => {
    return new Promise((resolve, reject) => {
        Axios.post(`${simplyBookServer}/login`, {
            "jsonrpc":"2.0",
            "method":"getToken",
            "params":[
                config.simplyBookApp,  config.simplyBookPublicKey
            ],
            "id":1
        }).then((response) => {
            if(response.status >= 200 && response.status <= 300){
                accessToken = response.data.result;
                resolve(response.data.result);

                axiosInstance = Axios.create({
                    baseURL: simplyBookServer,
                    timeout: 3000,
                    headers: {
                        'X-Company-Login': config.simplyBookApp,
                        'X-Token': accessToken,
                        'Content-Type': 'application/json'
                    }
                });

            }else{
                reject();
            }
        });
    });
};

export const getEvents = () => {
       return simplybookCall('getEventList')
};

export const makeBooking = (data) => {
    return firebaseServer.post('createBooking', {
        boothName: data.boothName,
        date: data.date,
        options: data.options,
        pricing: data.pricing,
        customerName: data.customerName,
        customerPhone: data.customerPhone,
        customerAddress: data.customerAddress,
        customerZip: data.customerZip,
        customerCity: data.customerCity,
        eventLocation: data.eventLocation,
        eventStreet: data.eventStreet,
        eventPostalCode: data.eventPostalCode,
        eventCity: data.eventCity,
        eventType: data.eventType,
        message: data.message
    });
};

export const submitMessage = (data) => {
    return firebaseServer.post('sendContact', {
        firstName: data.firstName,
        lastName: data.lastName,
        emailAddress: data.emailAddress,
        telephoneNumber: data.telephoneNumber,
        message: data.message
    });
}

export const getUnits = () => {
    return new Promise((resolve, reject) => {
        simplybookCall('getUnitList')
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject();
            })
    })
};

export const checkAvailability = (props) => {
    let eventDate = new Date(props.eventDate);
    return simplybookCall('getAvailableUnits', [props.eventId, `${eventDate.getFullYear()}-${eventDate.getMonth() + 1}-${eventDate.getDate()} 12:00:00`]);
}

function simplybookCall(method = '', params = [], id = 1) {
    return axiosInstance.post('/', {
        "jsonrpc":"2.0",
        "method": method,
        "params": params,
        "id": id
    })
}


// WEBPACK FOOTER //
// ./src/services/simplyBookService.js